var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAudioFile = function SvgAudioFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.274 6.324a.649.649 0 1 0-1.297 0v6.196l-2.962.808a2.405 2.405 0 1 0 1.267 4.64l.843-.231a2.92 2.92 0 0 0 2.15-2.816zm-3.917 8.256 2.62-.715v1.056c0 .731-.489 1.372-1.194 1.564l-.843.23a1.107 1.107 0 1 1-.583-2.135"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.919 0A2.92 2.92 0 0 0 2 2.919V21.08A2.92 2.92 0 0 0 4.919 24H18.54a2.92 2.92 0 0 0 2.918-2.919V5.58c0-.774-.307-1.517-.854-2.064l-2.66-2.66A2.92 2.92 0 0 0 15.88 0zM3.297 2.919c0-.896.726-1.622 1.622-1.622H15.88c.43 0 .842.171 1.146.475l2.66 2.66c.304.304.475.717.475 1.147V21.08c0 .896-.726 1.622-1.621 1.622H4.919a1.62 1.62 0 0 1-1.622-1.622z"
  })));
};
export default SvgAudioFile;